import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import Swal from "sweetalert2";
import { AUTH_URL } from "../../../utils/constants";
import { useAuth } from "../../../utils/AuthContext";

const OfficerLogin = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState({ email: "", password: "" });
  const { user, login } = useAuth();

  const handleValidation = () => {
    let isValid = true;
    let newError = { email: "", password: "" };

    // Email validation
    if (!email.trim()) {
      newError.email = "Email is required.";
      isValid = false;
    } else if (
      !/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(email)
    ) {
      newError.email = "Please enter a valid email address.";
      isValid = false;
    }

    // Password validation
    if (!password.trim()) {
      newError.password = "Password is required.";
      isValid = false;
    }

    setError(newError);
    return isValid;
  };

  const handleLogin = async () => {
    if (handleValidation()) {
      // Clear errors and navigate if validation passes
      try {
        let response = await axios.post(
          `${AUTH_URL}expertlogin`,
          { email: email, password: password },
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        );
        if (response?.data) {
          // sessionStorage.setItem("email", email);
          // sessionStorage.setItem("userId", response?.data?.id);
          // sessionStorage.setItem("name", response?.data?.name);
          const userData = {
            email: email,
            userId: response?.data?.id,
            name: response?.data?.name,
            role: response?.data?.role,
            category: response?.data?.officer_cag_category,
          };
          login(userData);
          navigate("/officerDesk");

          // login();
          // navigate("/officerDesk");
        }
      } catch (error) {
        console.log("Error in officer login api", error);
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Error in expert login",
        });
      }
      setError({ email: "", password: "" });
    }
  };

  const handleNavigate = () => {
    // Navigate to New User Registration
    navigate("/register");
  };

  return (
    // <div className="flex flex-col items-center justify-center py-[30px] ">
    //   <div className="w-[35%] border shadow-lg rounded-sm bg-white p-[15px]">
    //     <h1 className="mb-2 text-lg font-bold text-blue">OFFICER LOGIN</h1>
    //     <div className="my-3">
    //       <label
    //         htmlFor="email"
    //         className="block text-sm font-medium text-gray-700"
    //       >
    //         Email <span className="text-red-500">*</span>
    //       </label>
    //       <input
    //         type="email"
    //         id="email"
    //         value={email}
    //         onChange={(e) => setEmail(e.target.value)}
    //         className={`block w-full mt-1 p-1.5 bg-gray-200 border rounded-md shadow-sm sm:text-sm ${
    //           error.email ? "border-red-500" : "border-gray-300"
    //         } focus:ring-indigo-500 focus:border-indigo-500`}
    //         placeholder="Enter email"
    //       />
    //       {error.email && (
    //         <p className="mt-1 text-sm text-red-500">{error.email}</p>
    //       )}
    //     </div>
    //     <div className="my-3">
    //       <label
    //         htmlFor="password"
    //         className="block text-sm font-medium text-gray-700"
    //       >
    //         Password <span className="text-red-500">*</span>
    //       </label>
    //       <input
    //         type="password"
    //         id="password"
    //         value={password}
    //         onChange={(e) => setPassword(e.target.value)}
    //         className={`block w-full mt-1 p-1.5 bg-gray-200 border rounded-md shadow-sm sm:text-sm ${
    //           error.password ? "border-red-500" : "border-gray-300"
    //         } focus:ring-indigo-500 focus:border-indigo-500`}
    //         placeholder="Enter Password"
    //       />
    //       {error.password && (
    //         <p className="mt-1 text-sm text-red-500">{error.password}</p>
    //       )}
    //     </div>
    //     <div className="mt-6 mb-3 flex justify-center">
    //       <button
    //         className="w-[45%] bg-[#251e8a] hover:bg-[#1e1575] text-white py-1.5 rounded-md transition duration-300"
    //         onClick={handleLogin}
    //       >
    //         Login
    //       </button>
    //     </div>
    //     {/* <div className="mt-3 mb-1 text-sm flex justify-center items-center gap-x-1">
    //       <span>Forgot Password</span>
    //       <span className="h-4 border-l border-gray-500"></span>
    //       <p className="cursor-pointer text-blue-600" onClick={handleNavigate}>
    //         New User Registration
    //       </p>
    //     </div> */}
    //   </div>
    //   <div
    //     className="w-[35%] cursor-pointer border shadow-lg text-center text-[#943ab7] font-medium rounded-sm bg-white p-2"
    //     onClick={() => navigate("/login")}
    //   >
    //     USER LOGIN
    //   </div>
    // </div>
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-[#eaefff] to-[#ffffff] px-4">
      <div className="w-full max-w-md bg-white rounded-xl shadow-lg border border-gray-200 p-8 space-y-6">
        <div className="text-center">
          <h1 className="text-2xl font-bold text-[#251e8a]">Officer Login</h1>
          <p className="text-sm text-gray-500 mt-1">Authorized access only</p>
        </div>

        <div>
          <label htmlFor="email" className="block text-sm font-medium text-gray-700">
            Email <span className="text-red-500">*</span>
          </label>
          <input
            type="email"
            id="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className={`mt-1 w-full px-3 py-2 bg-gray-100 rounded-md border ${error.email ? "border-red-500" : "border-gray-300"
              } focus:outline-none focus:ring-2 focus:ring-[#251e8a]`}
            placeholder="Enter your email"
          />
          {error.email && <p className="text-sm text-red-500 mt-1">{error.email}</p>}
        </div>

        <div>
          <label htmlFor="password" className="block text-sm font-medium text-gray-700">
            Password <span className="text-red-500">*</span>
          </label>
          <input
            type="password"
            id="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className={`mt-1 w-full px-3 py-2 bg-gray-100 rounded-md border ${error.password ? "border-red-500" : "border-gray-300"
              } focus:outline-none focus:ring-2 focus:ring-[#251e8a]`}
            placeholder="Enter your password"
          />
          {error.password && <p className="text-sm text-red-500 mt-1">{error.password}</p>}
        </div>

        <button
          onClick={handleLogin}
          className="w-full bg-[#251e8a] text-white py-2 rounded-md font-semibold hover:bg-[#1e1575] transition duration-300"
        >
          Login
        </button>

        <div className="flex justify-between items-center text-sm text-gray-500">
          {/* <p
            onClick={() => navigate("/register")}
            className="text-blue-600 cursor-pointer hover:underline"
          >
            Register Officer
          </p> */}
          <p
            onClick={() => navigate("/login")}
            className="text-[#943ab7] font-semibold cursor-pointer hover:underline"
          >
            Switch to User Login
          </p>
        </div>
      </div>
    </div>
  );
};

export default OfficerLogin;
